import { Box } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CaseStudyImage from "../../assets/images/CaseStudyImage.webp";

const CaseStudiesBgLanding = () => {
  return (
    <Box
      sx={{
        width: "100%",
        paddingTop: { xs: "6rem", sm: "5rem" },
        backgroundColor: "#ecebeb",
      }}
    >
      <Box sx={{}}>
        <LazyLoadImage
          src={CaseStudyImage}
          effect="blur"
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default CaseStudiesBgLanding;
